import React, { FunctionComponent, useEffect } from "react";
import cls from "classnames";

import style from "./error.module.scss";

export enum ErrorType {
  Error,
  Warn,
  Info,
}

interface IError {
  isVisible: boolean;
  type?: ErrorType;
  message?: string;
  title?: string;
}

export const Error: FunctionComponent<IError> = ({
  isVisible = false,
  title = "",
  message = "",
  type = ErrorType.Info,
}) => {

  const computeClassType = (msgType: ErrorType) => {
    switch (msgType) {
      case ErrorType.Error:
        return style["error"];
      case ErrorType.Warn:
        return style["warn"];
      case ErrorType.Info:
      default:
        return style["info"];
    }
  };

  return (<div className={cls(style["wrapper"], {
    [style["visible"]]: isVisible,
  })}>
    <div className={style["card"]}>
      <h3 className={computeClassType(type)}> {title} </h3>
      <p> {message} </p>
    </div>
  </div>);
};
